import { call } from 'redux-saga/effects';

import createWorker from 'app/redux/utils/create-worker';
import workInterval from 'app/redux/utils/work-interval';

import constants from 'app/constants/cache';

import { arrayToObject } from 'app/utils/objects';

import questionsAPI from 'app/api/questions';

const randomize = array => {
  return array.sort(() => Math.random() - 0.5);
};

const randomizeQuestionOrder = questions => {
  const randomlyOrderedKeyArray = randomize(Object.keys(questions));

  const randomlyOrderedQuestionsObject = randomlyOrderedKeyArray.map(key => {
    const questionObject = questions[key];
    const randomizedAnswers = randomize(questionObject.answers);

    const fullyRandomizedQuestion = {
      ...questionObject,
      answers: randomizedAnswers,
    };

    return fullyRandomizedQuestion;
  });

  return arrayToObject(randomlyOrderedQuestionsObject, 'id');
};

const execute = function*() {
  const questionResponse = yield call(questionsAPI.getQuestions);
  const randomlyOrderedQuestions = randomizeQuestionOrder(questionResponse);

  return randomlyOrderedQuestions;
};

export const {
  Actions,
  Generators,
  ReducerHandlers,
  Saga,
  Types,
  initState,
  localStateSelector,
  Selectors,
} = createWorker('questions/get-all', {
  localStateSelector: 'questionsGetAll',
  execute,
  shouldWork: workInterval(constants.defaultUpdateIntervalInMilliseconds),
  takePolicy: 'latest',
});



// WEBPACK FOOTER //
// ./src/redux/questions/get-all/workers.js